import axios, { AxiosError } from 'axios';
import { PaginatedResult, Team } from '../types';
import { getToken } from '../utils/token';

type GetTeamsResult = PaginatedResult & {
  teams: Team[];
};

type GetTeamsResultWithError = {
  data?: GetTeamsResult | null;
  error?: any;
};

export const getTeams = async (
  page: number = 1,
  limit: number = 10,
  filters?: any
): Promise<GetTeamsResultWithError> => {
  let url = `${process.env.REACT_APP_API_ENDPOINT}/teams?page=${page}&limit=${limit}`;

  let query: string[] = [];

  if (filters) {
    if (filters.name) {
      query.push(`name=${filters.name}`);
    }
    url = url + '&' + query.join('&');
  }


  let result: GetTeamsResultWithError = {
    data: null,
    error: null,
  };

  try {
    const response = await axios.get(url, {
      headers: { Authorization: `Bearer ${getToken()}` },
    });

    result.data = response.data as GetTeamsResult;
  } catch (error: any) {
    const { response } = error as AxiosError;
    console.error('Error fetching teams:', error);
    result.error = response?.data;
  }

  return result;
};
